module.exports = __webpack_public_path__ + "img/title 1@2x.be89a035.png";